import { useOktaAuth } from '@okta/okta-react';
import { useDecodedToken } from './authorization.hook';
import { useBuildVars } from '../config/build-config/useBuildConfig';

type UserInfo = {
  email: string;
  family_name: string;
  given_name: string;
  name: string;
  preferred_username: string;
};

export function useUserInfo() {
  const decodedToken = useDecodedToken();
  if (decodedToken) {
    return {
      email: decodedToken.email,
      family_name: decodedToken.lastName,
      given_name: decodedToken.firstName,
      name: `${decodedToken.firstName} ${decodedToken.lastName}`,
      preferred_username: decodedToken.login,
    } as UserInfo;
  }
}

export function useIsAuthenticated() {
  const oktaContext = useOktaAuth();
  const { appId } = useBuildVars();
  const decodedToken = useDecodedToken();
  const isAuthenticated = oktaContext?.authState?.isAuthenticated === true;

  if (appId === 'x4ec') {
    const isAuthorized = !!decodedToken?.resellerId;
    return isAuthenticated && isAuthorized;
  }

  return isAuthenticated;
}

export function useIsTokenExpired() {
  const tokenExpiry = useDecodedToken()?.exp;
  return (
    tokenExpiry !== undefined &&
    tokenExpiry !== 0 &&
    tokenExpiry < Math.round(Date.now() / 1000)
  );
}

export async function fetchIpAdrress(): Promise<string> {
  const response = await fetch('/Site/ExternalHost/GetClientIp', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });
  if (response.ok) {
    const data = await response.json();
    return data['ClientIp'];
  }
  return '';
}
